import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "big-list-item" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Mutations } from '@/store';
import { WishlistItem } from '@/models/wishlist.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistItem',
  props: {
  item: {
    type: Object as PropType<WishlistItem>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const router = useRouter();

const editWishlistItem = () => {
  store.commit(Mutations.SetViewItem, props.item);
  router.push(`/wishlist/${props.item.url}/edit`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      href: props.item.link,
      target: "_blank"
    }, [
      _createElementVNode("span", {
        class: _normalizeClass('icon icon-keyboard'),
        onClick: _withModifiers(editWishlistItem, ["prevent"])
      }, null, 8, _hoisted_3),
      _createElementVNode("h2", {
        textContent: _toDisplayString(props.item.name)
      }, null, 8, _hoisted_4),
      _createElementVNode("span", {
        class: "big-list-item__subtext",
        textContent: _toDisplayString(`(${props.item.release})`)
      }, null, 8, _hoisted_5)
    ], 8, _hoisted_2)
  ]))
}
}

})